import { Link } from 'react-router-dom';
import styles from './Breadcrumb.module.css';

export type Crumb = { label: string; to?: string };

export function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav className={styles.crumb} aria-label="Breadcrumb">
      {items.map((c, i) => (
        <span key={`${c.label}-${i}`}>
          {i > 0 ? <span className={styles.sep}>›</span> : null}
          {c.to ? (
            <Link to={c.to}>{c.label}</Link>
          ) : (
            <span className={styles.current}>{c.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
